import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as DocumentDetails } from 'assets/icons/document-details.svg';

import ModalVehicleDetails from 'components/rentingRedRac/VehicleDetails';

import {
    checkAuctionIsActive,
    formatNumber,
} from 'js/components/shared/vehicleFunctions';
import { disableHTMLOverflow, formatDate } from 'Functions';

import { vehicleTypes } from 'components/rentingRedRac/types';

const Card = ({
    item: vehicle,
    serverTime,
    onSelectVehicle,
    selectedVehicle,
}) => {
    const [vehicleDetailVisible, setVehicleDetailVisible] = useState(false);
    const dateExpiredClass = useMemo(
        () =>
            checkAuctionIsActive(
                serverTime - 1,
                vehicle.ExpirationDate,
                serverTime
            )
                ? ''
                : 'u-text-alert',
        [serverTime, vehicle.ExpirationDate]
    );

    const onShowDetailClick = useCallback(() => {
        setVehicleDetailVisible(currentStatus => {
            disableHTMLOverflow(!currentStatus);
            return !currentStatus;
        });
    }, []);

    return (
        <>
            <tr
                className={`${
                    selectedVehicle?.Id === vehicle?.Id
                        ? 'u-bg-alternative-darken'
                        : ''
                }`}
                style={{ cursor: 'pointer' }}
                onClick={() => onSelectVehicle(vehicle)}
            >
                <td>{vehicle.Plate}</td>
                <td>
                    <img
                        style={{ height: '40px', width: '40px' }}
                        src={
                            process.env.PUBLIC_URL +
                            '/Bronson/img/' +
                            vehicle.Brand.replace(/ +/g, '').toLowerCase() +
                            '-320x320px.png'
                        }
                        alt={`${vehicle.Brand} icon`}
                    />
                </td>
                <td>{vehicle.Model}</td>
                <td>
                    <span className={`${dateExpiredClass}`}>
                        {formatDate(vehicle.ExpirationDate)}
                    </span>
                </td>
                <td>{vehicle.Dealer}</td>
                <td>
                    <strong>
                        {formatNumber(vehicle.MinimumPrice.toFixed(2))}€
                    </strong>
                </td>
                <td>{formatDate(vehicle.FromDateAmount)}</td>
                <td>
                    <button
                        className="c-btn  c-btn--link  c-btn--small  c-btn--simple"
                        onClick={e => {
                            e.stopPropagation();
                            onShowDetailClick();
                        }}
                    >
                        <DocumentDetails
                            height="24"
                            width="24"
                            fill="#004666"
                            className="c-icon c-btn__icon c-icon--small"
                            alt="Open details icon"
                        />
                    </button>
                </td>
            </tr>
            {vehicleDetailVisible && (
                <tr>
                    <td>
                        <ModalVehicleDetails
                            onShowDetail={onShowDetailClick}
                            vehicle={vehicle}
                        />
                    </td>
                </tr>
            )}
        </>
    );
};

Card.propTypes = {
    item: vehicleTypes,
    selectedVehicle: PropTypes.shape({ Id: PropTypes.string.isRequired }),
    onSelectVehicle: PropTypes.func.isRequired,
    serverTime: PropTypes.string,
};

export default Card;
